module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-gift5000_e5f1ecc255eef8fa53fa6efc0d1c5d14.png";